export class RoomManager {

	roomID = "";
	room = null;

	configureRoom(eventHandler, cb = null) {
		this.loadRoomDetail((room) => {
			this.onRoomLoaded(room, eventHandler)
			if (cb !== null)
				cb(room)
		}, true); //We skip cache to ensure we dont miss any new players
	}

	setRoomID(roomID) {
		console.log("RoomManager: Setting room ID to " + roomID);
		this.roomID = roomID;
	}

	getRoom(cb) {
		if (this.room !== null)
			cb(this.room)
		else
			this.loadRoomDetail(null, (room) => {
				cb(room)
			})
	}

	loadRoomDetail(cb = null, skipCache = false) {
		if (!skipCache && (this.room != null && this.room.id !== this.roomID)) {
			console.log("Skipping repeated room load")
			if (cb !== null)
				cb(this.room)
			return
		}

		console.log("Loading room detail", this.roomID)

		const data = null;
		const xhr = new XMLHttpRequest();
		// xhr.withCredentials = true;

		xhr.onload = () => {
			console.log("Loaded: ", xhr.responseText)
			this.room = JSON.parse(xhr.responseText);

			if (cb !== null)
				cb(this.room)
		};

		xhr.open("GET", `https://app.alphabatem.com/rooms/${this.roomID}/ws_detail`);
		xhr.send(data);
	}

	onRoomLoaded(data, eventHandler) {
		console.log("Room loaded", data)
		console.log("Handler: ", eventHandler)

		//TODO Populate chatbox

		//TODO Populate existing players
		for (let i in data.player_positions) {
			console.log("Adding existing room player: ",i, data.player_positions[i]);

			const plr = data.player_positions[i]

			plr.token_addr = plr.public_addr
			plr.player_uid = i
			plr.existing = true;
			plr.user_id = i
			plr.username = plr.name
			plr.custom_sprite = plr.sprite_url

			eventHandler.onPlayerAdd(plr)
			eventHandler.onPlayerMove(plr)
		}

		window.dispatchEvent(new CustomEvent('room-loaded'))
		//TODO Puplulate existing items
	}

	reset() {
		this.roomID = "";
		this.room = null;
	}
}